import { getConfig } from './utils';

export function getNumberConfig(name: string, defaultVal: number): number {
  const value = getConfig()?.Number?.[name];
  return value ?? defaultVal;
}

export function getStringConfig(name: string, defaultVal: string): string {
  const value = getConfig()?.String?.[name];
  return value ?? defaultVal;
}

export function getBooleanConfig(name: string, defaultVal: boolean): boolean {
  const value = getConfig()?.Boolean?.[name];
  return value ?? defaultVal;
}

export function getStringListConfig(name: string, defaultVal: Array<string>): Array<string> {
  const value = getConfig()?.StringCsv?.[name];
  if (typeof value === 'undefined') {
    return defaultVal;
  }
  return value.split(',');
}

export function getNumberListConfig(name: string, defaultVal: Array<number>): Array<number> {
  const value = getConfig()?.NumberCsv?.[name];
  if (typeof value === 'undefined') {
    return defaultVal;
  }
  return value.split(',').map(Number);
}
